<template>
  <div class="container">
    <!-- 存储空间 -->
    <div class="progress">
      <div class="progress_wapper">
        <p>存储空间</p>
        <el-progress :show-text="false" :percentage="percentage"></el-progress>
        <p>{{ cloudUserSize }} / {{ cloudFileSize }}</p>
      </div>
    </div>
    <div class="top">
      <div class="search">
        <el-input placeholder="请输入题名" v-model="keyWords" @keyup.enter.native="toSearch" clearable></el-input>
        <span class="search_img" @click="toSearch"><img src="../../assets/images/search_icon.png" /></span>
      </div>
      <el-button type="primary" @click="toAdd">新增</el-button>
    </div>

    <div class="table-info">
      <el-table class="table" :data="tableData" :cell-style="tableCellStyle" :header-cell-style="tableHeaderCellStyle" border style="width: 100%">
        <el-table-column label="题名" align="center" show-overflow-tooltip>
          <template slot-scope="scope" label="题名">
            <span :class="{ titlecn: scope.row.realOwner == 0 }" @click="toPDF(scope.row)" v-safe-html="scope.row.literatureName"></span>
          </template>
        </el-table-column>
        <el-table-column label="作者" prop="paperAuthor" align="center" show-overflow-tooltip> </el-table-column>
        <el-table-column label="发布日期" prop="createTime" align="center" width="160"> </el-table-column>
        <el-table-column label="类型" align="center" show-overflow-tooltip width="80">
          <template slot-scope="scope" label="操作">
            {{ scope.row.literatureType == 10 ? "文章" : "附件" }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="230">
          <template slot-scope="scope" label="操作">
            <el-button type="text" v-if="scope.row.literatureType == 10" @click="toDetail(scope.row)">查看详情</el-button>
            <el-button type="text" :class="{ noClick: scope.row.sysOwner != 1 }" @click="upload(scope.row)">上传附件</el-button>
            <!-- <el-button type="text" v-if="scope.row.realOwner == 0" @click="download(scope.row)">解析</el-button> -->
            <el-button type="text" @click="toDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" hide-on-single-page> </el-pagination>
    </div>
    <!-- 上传附件 -->
    <el-dialog title="上传附件" :visible.sync="uploadVisible" width="35%" class="noHeight">
      <div class="upload_wapper">
        <el-upload class="upload-demo" drag :action="uploadAction" accept=".pdf" :before-upload="handleBeforeUpload" :file-list="fileList" multiple :on-success="uploadSuccess">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <p class="file_name" v-if="fileName">
          <label class="line1">{{ fileName }}</label>
          <span @click="delFile">删除</span>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="uploadVisible = false">取消</el-button>
        <el-button type="primary" :loading="fileLoading" @click="saveFile">确认</el-button>
      </span>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog title="新增" :visible.sync="addVisible" width="40%" :class="{ noHeight: fileName }">
      <div v-loading="!fileName && fileLoading">
        <template v-if="!fileName">
          <p class="add_title">搜索添加</p>
          <div class="top noMargin">
            <div class="search w100">
              <el-input placeholder="请输入题名" v-model="addWords" @keyup.enter.native="toAddSearch" clearable @input="searchKeyword"></el-input>
              <span class="search_img" @click="toAddSearch"><img src="../../assets/images/search_icon.png" /></span>
            </div>
          </div>
        </template>

        <!-- 输入联想弹出层 -->
        <div class="search-input" v-if="searchFlag">
          <ul>
            <li v-for="(item, index) in keywordDataList" :key="index">
              <span v-safe-html="item.suggestionWord"></span>

              <el-button disabled v-if="item.isAdd" type="text">已添加</el-button>
              <el-button v-else @click="saveAdd(item.sid)" type="text">添加</el-button>
            </li>
          </ul>
        </div>
        <!-- 搜索功能 -->
        <div class="articleList" v-if="addWords && articleDataList.length > 0">
          <ul>
            <li v-for="(item, index) in articleDataList" :key="index">
              <div>
                <p v-safe-html="item.title"></p>
                <p v-if="item.authorStr">
                  作者：<span>{{ item.authorStr }}</span>
                </p>

                <p>
                  期刊信息：
                  <span>{{ item.journalName }}</span>
                  <label v-if="item.year">{{ item.year }} ; </label>{{ item.volume }}<label v-if="item.issue && item.issue != 'null'">({{ item.issue }})</label>
                </p>
              </div>
              <el-button disabled v-if="item.isAdd" type="text">已添加</el-button>
              <el-button v-else @click="saveAdd(item.sid)" type="text">添加</el-button>
            </li>
          </ul>
          <el-pagination @current-change="handleAddCurrentChange" :current-page="pageAddNo" :page-size="pageAddSize" layout="total, prev, pager, next, jumper" :total="addTotal" hide-on-single-page> </el-pagination>
        </div>
        <!-- 暂无数据 -->
        <div class="noData" v-if="addWords && addTotal <= 0 && !searchFlag">
          <img src="../../assets/images/noData.png" />
        </div>
        <template v-if="!addWords.trim()">
          <p class="add_title" :class="{ mt30: !fileName }">本地文件上传</p>
          <div class="upload_wapper">
            <el-upload class="upload-demo" drag :action="uploadAction" accept=".pdf" :before-upload="handleBeforeUpload" :file-list="fileList" multiple :on-success="uploadSuccess">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <p class="file_name" v-if="fileName">
              <label class="line1">{{ fileName }}</label>
              <span @click="delFile">删除</span>
            </p>
          </div>
        </template>
      </div>

      <span slot="footer" class="dialog-footer" v-if="fileName">
        <el-button type="info" @click="addVisible = false">取消</el-button>
        <el-button type="primary" :loading="fileLoading" @click="saveFile">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import baseurl from "../../api/baseurl";
export default {
  name: "MyCloud",
  data() {
    return {
      tableData: [],
      pageNo: 1,

      pageSize: 10,
      keyWords: "",
      total: 100,
      uploadVisible: false,
      fileList: [],
      fileName: "",
      fileLoading: false,
      uploadAction: baseurl.baseUrl + "api/v1/user/literature/upload/customize",
      cloudFileSize: "",
      cloudUserSize: "",
      percentage: 0,
      // 新增
      addVisible: false,
      addWords: "",
      pageAddNo: 1,
      pageAddSize: 5,
      addTotal: 0,
      searchFlag: false,
      keywordDataList: [],
      articleDataList: [],
    };
  },
  mounted() {
    this.getList();
    this.getInfo();
  },
  methods: {
    // 修改表格边框颜色
    tableCellStyle() {
      return "border-color: #CCCCCC; ";
    },
    tableHeaderCellStyle() {
      return "border-color: #CCCCCC; color: #666; background:#eee;";
    },
    getInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.percentage = parseInt(((res.data.usedFileSize / res.data.fileSize) * 100).toFixed(0));
        this.cloudFileSize = this.bytesToSize(res.data.fileSize);
        this.cloudUserSize = this.bytesToSize(res.data.usedFileSize);
      });
    },
    bytesToSize(bytes) {
      if (bytes === 0) return "0 B";

      var k = 1024;

      let sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      let i = Math.floor(Math.log(bytes) / Math.log(k));

      return (bytes / Math.pow(k, i)).toFixed(1) + sizes[i];
      //toPrecision(3) 后面保留一位小数，如1.0GB                                                                                                                  //return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
    },
    toSearch() {
      this.pageNo = 1;
      this.getList();
    },
    toAdd() {
      this.addWords = "";
      this.keywordDataList = [];
      this.articleDataList = [];
      this.pageAddNo = 1;

      this.fileSid = "";
      this.sid = "";
      this.fileName = "";
      this.fileList = [];

      this.addVisible = true;
    },
    getList() {
      let postBody = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        searchWords: this.keyWords.trim(),
      };
      this.$http({
        url: "api/v1/user/literature/list",
        method: "POST",
        data: postBody,
      }).then(res => {
        this.total = res.total;
        this.tableData = res.rows;
      });
    },
    upload(row) {
      this.fileList = [];
      this.sid = "";
      this.fileSid = "";
      this.fileName = "";
      if (row.sysOwner == 1) {
        this.uploadVisible = true;
        this.sid = row.sid;
      }
    },
    // 点击题名跳转pdf预览
    toPDF(row) {
      if (row.realOwner == 1) {
        return;
      }
      if (window.__POWERED_BY_QIANKUN__) {
        const jyx_token = localStorage.getItem("jyx_token") || "";
        routeUrl = baseurl.baseUrl + `pdf?sid=${row.sid}&jyx_token=${encodeURIComponent(jyx_token)}`;
      } else {
        const route = this.$router.resolve({
          path: "/pdf",
          query: {
            sid: row.sid,
          },
        });
        routeUrl = route.href;
      }
      window.open(routeUrl, "_blank");
    },
    toDetail(row) {
      let _url = this.$router.resolve({
        path: "/articleDetail",
        query: { sid: row.paperSid },
      });
      window.open(_url.href, "_self");
    },
    // 删除文献
    toDelete(row) {
      this.$confirm("确定要删除此文献吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http({
            url: "api/v1/user/literature/delete?sid=" + row.sid,
            method: "get",
          }).then(res => {
            if (res.code == 200) {
              this.pageNo = 1;
              this.$message.success("删除成功");
              this.getList();
              this.getInfo();
            }
          });
        })
        .catch(() => {});
    },
    handleBeforeUpload(file) {
      const isPDF = file.type === "application/pdf";
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isPDF) {
        this.$message.error("文件只能是 PDF 格式!");
      } else if (!isLt10M) {
        this.$message.error("上传的文件不能超过 10MB!");
      } else {
        this.fileLoading = true;
        this.fileList = [file]; // 更新文件列表
      }

      return isPDF && isLt10M;
    },
    // 上传成功时调用此接口
    uploadSuccess(response, file, fileList) {
      this.fileName = file.name;
      this.fileSid = response.data.sid;
      this.fileLoading = false;
    },
    // 删除文件
    delFile() {
      this.fileSid = "";
      this.sid = "";
      this.fileName = "";
      this.fileList = [];
    },
    saveFile() {
      if (!this.fileSid) {
        this.$message.error("请上传附件");
        return;
      }
      this.$http({
        url: `api/v1/user/literature/add/upload/file?fileSid=${this.fileSid}&sid=${this.sid}`,
        method: "get",
      }).then(res => {
        if (res.code == 200) {
          this.uploadVisible = false;
          this.$message.success("保存成功");
          this.fileSid = "";
          this.sid = "";
          this.fileName = "";
          this.fileList = [];
          this.getInfo();
          this.getList();
        }
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getList();
    },
    // 新增
    // 搜索框输入事件
    searchKeyword() {
      if (this.addWords) {
        this.searchFlag = true;
        this.articleDataList = [];
        this.pageAddNo = 1;
        this.addTotal = 0;
        this.getKeywordData();
      } else {
        this.searchFlag = false;
      }
    },
    // 根据输入的内容获取联想数据
    getKeywordData() {
      let postBody = {
        word: this.addWords,
      };
      this.$http({
        url: `api/v1/user/literature/suggestion`,
        method: "post",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          if (res.data.length == 0) {
            this.searchFlag = false;
          }
          this.keywordDataList = res.data;
        }
      });
    },
    toAddSearch() {
      this.searchFlag = false;
      if (!this.addWords.trim()) {
        return;
      }
      this.getArticleList();
    },
    getArticleList() {
      let postBody = {
        searchWord: this.addWords.trim(),
        searchFields: [],
        pageNo: this.pageAddNo,
        pageSize: this.pageAddSize,
        orderField: "_score",
        orderType: "DESC",
        metricFilterList: [],
        paramList: [],
        sourceList: [],
        publishYearStart: null,
        publishYearEnd: null,
      };
      this.loading = true;
      this.$http({
        url: "api/v1/user/literature/paper/list",
        method: "POST",
        data: postBody,
      }).then(res => {
        this.loading = false;
        this.addTotal = res.data.recordCount > 10000 ? 10000 : res.data.recordCount;
        this.articleDataList = res.data.recordList;
        // 替换作者逗号  变成分号
        this.articleDataList.forEach((element, index) => {
          if (element.author) {
            this.articleDataList[index].authorStr = element.author.replace(/,/g, "；");
          } else {
            this.articleDataList[index].authorStr = "";
          }
        });
      });
    },
    saveAdd(sid) {
      this.$http({
        url: "api/v1/user/literature/add/paper?paperSid=" + sid,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("添加成功");
          this.getList();
          // 搜索出的数据
          if (this.articleDataList.length > 0) {
            this.getArticleList();
          }
          // 联想出的数据
          if (this.keywordDataList.length > 0) {
            this.getKeywordData();
          }

          this.pageNo = 1;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleAddCurrentChange(val) {
      this.pageAddNo = val;
      this.getArticleList();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table .el-table__header {
  width: 100% !important;
}
::v-deep .el-table .el-table__body {
  width: 100% !important;
}
.el-table {
  border: 1px solid #cccccc;
}
::v-deep .el-progress-bar__outer {
  background: #fff;
}

.container {
  padding: 30px;
  .titlecn {
    cursor: pointer;
    &:hover {
      color: #2d8cf0;
    }
  }
  .noMargin {
    margin: 0 !important;
    padding: 0 !important;
  }
  .top {
    display: flex;
    align-items: center;
    padding-bottom: 15px;
    margin-top: 30px;
    position: relative;

    .search {
      display: flex;
      align-items: center;
      background: #fff;
      border: 1px solid #cccccc;
      margin-left: auto;
      ::v-deep .el-input__inner {
        border: none;
        border-radius: 0;
        height: 30px;
        line-height: 30px;
      }
      ::v-deep .el-input__icon {
        line-height: 30px;
      }
      .el-input {
        width: 280px;
      }
      .search_img {
        width: 40px;
        height: 30px;
        background: #2d8cf0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }

    .w100 {
      width: 100% !important;
      .el-input {
        width: 100% !important;
      }
      ::v-deep .el-input__inner {
        height: 40px !important;
        line-height: 40px !important;
      }
      .search_img {
        width: 60px;
        height: 40px;
        background: #2d8cf0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
    .el-button {
      height: 32px;
      line-height: 32px;
      padding: 0;
      border-radius: 0;
      width: 58px;
      margin-left: 20px;
    }
  }
  ::v-deep .el-dialog__header {
    background: #2d8cf0;
    padding: 15px 15px 15px 30px;
    .el-dialog__title,
    .el-dialog__close {
      color: #fff;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 30px;
    min-height: 404px;
  }
  .noHeight {
    ::v-deep .el-dialog__body {
      padding: 30px;
      min-height: auto;
    }
  }
  ::v-deep .el-dialog__footer {
    padding: 20px 30px;
    padding-top: 0px;
  }
  .dialog-footer {
    .el-button {
      border-radius: 0;
      border: none;
    }
    .el-button--info {
      color: #333;
      background: #f7f7f7;
    }
  }
  .upload_wapper {
    ::v-deep .upload-demo {
      .el-upload {
        border: 5px solid rgba(21, 186, 188, 0.1);
        border-radius: 6px;
        width: 100%;
      }
      .el-upload-dragger {
        border: 1px dashed #2d8cf0;
        width: 100%;
        height: 190px;
      }
      .el-upload__text {
        font-size: 16px;
      }
      .el-upload-list {
        display: none;
      }
    }
    .file_name {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      margin-top: 10px;
      label {
        width: 80%;
      }
      span {
        color: #2d8cf0;
        cursor: pointer;
      }
    }
  }
  .noClick {
    color: #cccccc;
    cursor: default;
  }

  .progress {
    background: #f7f7f7;
    width: 100%;
    padding: 20px 30px;
    .progress_wapper {
      width: 400px;
    }
    p {
      font-size: 14px;
      color: #666;
      &:nth-of-type(1) {
        color: #333;
        font-weight: bold;
      }
    }
    .el-progress {
      margin: 8px 0;
    }
  }
  .mt30 {
    margin-top: 30px;
  }
  .add_title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
  }
  .search-input {
    li {
      display: flex;
      align-items: baseline;
      font-size: 16px;
      color: #333;
      justify-content: space-between;
      margin-top: 20px;
      // &:last-of-type {
      //   margin: 0;
      // }
      span {
        width: 90%;
        display: inline-block;
      }
      .el-button {
        font-size: 16px;
        padding: 0;
      }
    }
  }
  .articleList {
    ul {
      li {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        margin-top: 20px;
        div {
          width: 90%;
          p {
            margin-bottom: 10px;
            font-size: 16px;
            color: #666;
            &:nth-of-type(1) {
              color: #333;
              font-weight: bold;
            }
            &:last-of-type {
              margin: 0;
            }
          }
        }
        .el-button {
          font-size: 16px;
          padding: 0;
        }
      }
    }
  }
  .noData {
    margin-top: 40px;
    margin-bottom: 0;
    min-height: auto;
  }
  ::v-deep .el-pagination {
    padding-bottom: 10px !important;
  }
}
</style>
